import * as ng from 'angular';
import { ComponentRegistration } from '../../../core';
import { Dto } from '../../../data';
import { IAccountRequestService } from './../';
let template = require('./dashboard-grid.html');

class DashboardGridComponent extends ComponentRegistration {

    constructor() {
        super('dashboardGrid', {
            controller: DashboardGridController,
            templateUrl: template,
            controllerAs: 'vm',
            bindings: {
                userSelected: '&?'
            }
        });
    }
}

interface IDashboardGridController {

}

class DashboardGridController implements IDashboardGridController {
    private static $inject: Array<string> = ['AccountRequestService'];
    private criteria: Dto.IAccountRequestCriteria;
    private accountRequests: {};

    //Bindings
    private userSelected: Function;

    constructor(private AccountRequestService: IAccountRequestService) {
        console.log('DashboardGridController loading');
        this.activate();
    }

    public activate(): void {
        console.log('DashboardGridController loaded');
    }

    public $onInit(): void {
        this.criteria = {
            pageSize: 25,
            pageNumber: 1,      
            isPendingApproval:true           
        } as Dto.IAccountRequestCriteria;
        this.search(this.criteria);
    }

    public search(criteria?: Dto.IAccountRequestCriteria): ng.IPromise<Array<Dto.IAccountRequest>> {
        return this.AccountRequestService.search(criteria).then((accountRequests) => {
            return this.accountRequests = accountRequests;
        });
    }

    public criteriaChanged(args) {
        this.criteria = args.criteria;
        this.search(this.criteria);
    }

    public onRowSelect(selectedRow): void {
        if (!selectedRow) {
            this.raiseUserSelected();
            return;
        }
        this.raiseUserSelected(selectedRow.entity);
    }

    public raiseUserSelected(profile?: Dto.IAccountRequest): void {
        if (typeof this.userSelected === 'function') {
            this.userSelected({ profile: profile });
        }
    }
}

let dashboardGridComponent = new DashboardGridComponent();
export default dashboardGridComponent;
export { dashboardGridComponent as DashboardGridComponent, IDashboardGridController, DashboardGridController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/admin/dashboard/dashboard-grid.ts